export const fistNames = [
    "Léa",
    "Arthur",
    "Chloé",
    "Gabriel",
    "Inès",
    "Lucas",
    "Camille",
    "Louis",
    "Emma",
    "Hugo",
    "Jade",
    "Nathan",
    "Alice",
    "Adam",
    "Louise",
    "Maxime",
    "Manon",
    "Théo",
    "Clara",
    "Enzo",
    "Sarah",
    "Thomas",
    "Anaïs",
    "Raphaël",
    "Zoé",
    "Mathis",
    "Lucie",
    "Victor",
    "Maëlys",
    "Émilie",
    "Noé",
    "Julie",
    "Léo",
    "Éléonore",
    "Valentin",
    "Élisa",
    "Julien",
    "Charlotte",
    "Antoine",
    "Margaux",
    "Paul",
    "Ambre",
    "Simon",
    "Élodie",
    "Quentin",
    "Mathilde",
    "Sacha",
    "Romane",
    "Romain",
    "Océane",
];

export const lastNames = [
    "Dupont",
    "Martin",
    "Lefebvre",
    "Leroy",
    "Moreau",
    "Simon",
    "Laurent",
    "Girard",
    "Roux",
    "Michel",
    "Dubois",
    "Garnier",
    "Leclerc",
    "Petit",
    "Fournier",
    "François",
    "Bertrand",
    "Lambert",
    "Fontaine",
    "Rousseau",
    "Vincent",
    "Muller",
    "Morel",
    "Blanc",
    "Gauthier",
    "Pons",
    "Dumont",
    "Durand",
    "Bonnet",
    "Marchand",
    "Marion",
    "Perrin",
    "Robin",
    "Richard",
    "Lefèvre",
    "Dupuis",
    "Caron",
    "Boucher",
    "Guillot",
    "Masson",
    "Brun",
    "Millet",
    "Charles",
    "Fabre",
    "André",
    "Morin",
    "Blanchard",
    "Henry",
    "Bourdon",
    "Renaud",
];

export const jobs = [
    "Artisan ébéniste",
    "Photographe de nature",
    "Musicien",
    "Jardinier botaniste",
    "Chef cuisinier",
    "Écrivain",
    "Couturier",
    "Guide de montagne",
    "Plongeur sous-marin",
    "Vigneron",
    "Graphiste",
    "Architecte",
    "Céramiste",
    "Danseur de ballet",
    "Pilote d'avion",
    "Sculpteur",
    "Astronome amateur",
    "Comédien",
    "Photographe de mariage",
    "Maître chocolatier",
    "Professeur de yoga",
    "Apiculteur",
    "Cinéaste",
    "Poissonnier",
    "Entraîneur sportif",
    "Horloger",
    "Chanteur d'opéra",
    "Designer de mode",
    "Guide touristique",
    "Tatoueur",
    "Éleveur de chevaux",
    "Créateur de jeux vidéo",
    "Marin pêcheur",
    "Peintre",
    "Boulanger",
    "Chocolatier",
    "Restaurateur de meubles anciens",
    "Ingénieur du son",
    "Organisateur de mariages",
    "Mosaïste",
    "DJ",
    "Vétérinaire",
    "Parfumeur",
    "Plombier",
    "Créateur de bijoux",
    "Joueur de poker professionnel",
    "Forgeron",
    "Directeur de théâtre",
    "Mixologue",
    "Aquarelliste",
];
